import { connect } from 'react-redux'
import CurrentEntry from './current-entry'
import {
  getInvitation,
  getRemoveInvitationRequest
} from '../../../../../../stores/current-invitations/current-invitations.selectors'
import { format } from 'date-fns'
import { withRouter } from 'react-router-dom'
import { markAsSeen } from '../../../../../../stores/current-invitations/current-invitations.actions'

const mapStateToProps = (state, { id, index }) => {
  const currentInvitation = getInvitation(state, id)
  const removeInvitationRequest = getRemoveInvitationRequest(state, id)
  return {
    id: currentInvitation.id,
    index: index,
    title: currentInvitation.assessment_file.title,
    invitedBy: currentInvitation.invited_by.full_name,
    invitedAt: format(currentInvitation.created_at, 'DD.MM.YYYY'),
    url: `/assessment-files/${currentInvitation.assessment_file.id}`,
    seen: currentInvitation.seen,
    conclusion: currentInvitation.assessment_file.concluded,
    pending: removeInvitationRequest.pending,
    school:
      (currentInvitation.assessment_file.student_types &&
        currentInvitation.assessment_file.student_types.length > 0 &&
        currentInvitation.assessment_file.student_types[0] &&
        currentInvitation.assessment_file.student_types[0].school &&
        currentInvitation.assessment_file.student_types[0].school.title) ||
      '-'
  }
}

const mapDispatchToProps = (dispatch, { history }) => ({
  onInvitationClick: (url, id) =>
    dispatch(markAsSeen(id)).then(() => history.push(url))
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CurrentEntry)
)
